<div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
          <div class="card">
              <div class="col-lg-12">
                  <div style="display: flex; flex-wrap: nowrap; height: 30px">
                      <label>{{ "AssOwner" | translate }}</label>
                      <span *ngIf="AssignedUser.invalid" class="alert" style="color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px;">
                          <div *ngIf="AssignedUser.errors?.required">*</div>
                      </span>
                  </div>
                  <ng-select required
                             #AssignedUser="ngModel"
                             class="form-control-select"
                             [items]="usersArr"
                             bindLabel="text"
                             bindValue="id"
                             [(ngModel)]="selectedUserId"
                             [ngModelOptions]="{ standalone: true }"
                             placeholder="{{ 'AssOwner' | translate }}">
                  </ng-select>

              </div>
              <br />
           

              <div class="col-12 row">
                  <div class="col-9"></div>
                  <button type="button" class="btn btn-primary col-3 mt-3" [disabled]="AssignedUser.invalid" (click)="SaveAssignUser()">
                      {{ "Save" | translate }}
                  </button>
              </div>
          </div>
            </div>
            </div>
</div>